import React, {useState} from 'react'
import {Modal, Input, Row, Col, Upload, notification, Tooltip } from 'antd'

function ProductModalNew(props){
    const[nombre, setNombre] = useState("");
    const[description, setDescription] = useState("");
    const[price, setPrice] = useState("");
    const[prodId, setProdId] = useState("");
    const [fileList, setFileList] = useState([]);

    const msNotification = (type, title, desc) => {
        notification[type]({
            message: title,
            description:
            desc,
        });
    };

    const handleOk = () => {
        if(prodId !== ""){
            if(nombre !== ""){
                if(description !== ""){
                    if(price !== "" && price > 0){
                        if(fileList.length > 0){
                            fileList.forEach(file => {
                                const reader = new FileReader();
                                
                                reader.readAsDataURL(file.originFileObj);
                                reader.onload = ({ target }) => { 
                                    const result = target.result; 
                                    const values = { 
                                        name: file.name, 
                                        size: file.size,
                                        base64Data: result.split(",")[1], 
                                        type: result.split(";")[0].split(":")[1] 
                                    };
                
                                    const newProduct = {
                                        image : values.base64Data,
                                        mediaType : values.type,
                                        name : values.name,
                                        prodName: nombre,
                                        prodDesc: description,
                                        prodPrice: price,
                                        prodId: prodId
                                    }
                                    setFileList([]);
                                    props.handleOkModalNew(newProduct);
                                    setNombre("");
                                    setDescription("");
                                    setPrice("");
                                    setProdId("");
                                    
                                }; 
                                
                            });
                        }else{
                            const newProduct = {
                                image : null,
                                mediaType : null,
                                name : null,
                                prodName: nombre,
                                prodDesc: description,
                                prodPrice: price,
                                prodId: prodId
                            }
                            props.handleOkModalNew(newProduct);
                            setNombre("");
                            setDescription("");
                            setPrice("");
                            setProdId("");
                        }
    
                    }else{
                        msNotification('warning', 'Producto', 'El precio del producto no debe de ser vacio.');
                    }
                }else{
                    msNotification('warning', 'Producto', 'La descripción del producto no debe de ser vacio.');
                }
            }else{
                msNotification('warning', 'Producto', 'El nombre del producto no debe de ser vacio.');
            }
        }else{
            msNotification('warning', 'Producto', 'El Id del producto no debe de ser vacio.');
        }
        
      };

    const handleCancel = () => {
        setFileList([]);
        setNombre("");
        setDescription("");
        setPrice("");
        setProdId("");
        props.handleCancelModalNew();
    }

    const handleNameChange = (e) => {
        setNombre(e.target.value);
    }

    const handleIdChange = (e) => {
        setProdId(e.target.value);
    }

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    const handlePriceChange = (e) => {
        const { value } = e.target;
        const reg = /^-?\d*(\.\d*)?$/;
        if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
            setPrice(value);
        }
        
    }

    const propsUpload = {
        onRemove: file => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
         
        },
        beforeUpload: (newFile ) => {
            console.log(newFile)
            if (newFile.type === 'image/png' || newFile.type === 'image/jpeg') {
                const oldList = [...fileList];
                oldList.push(newFile);
                setFileList(oldList);
                return false;
                
              }else{
                msNotification('warning', 'Categoría', `${newFile.name} el archivo no es .png o .jpg`);
                
              }
              return newFile.type === 'image/png' ? false : newFile.type === 'image/jpeg' ? false : Upload.LIST_IGNORE;
            
        },
        fileList,
        listType: "picture-card",
        onPreview: file => {
            let src = file.url;
            if (!src) {
              src = new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
              });
            }
            const image = new Image();
            image.src = src;
            const imgWindow = window.open(src);
            imgWindow.document.write(image.outerHTML);
        },
        onChange: ({ fileList: newFileList }) => {
            setFileList(newFileList);
        }
      };

    return(
        <React.Fragment>
            <Modal title="Nuevo Producto" 
            visible={props.modalVisibleNew} 
            onOk={handleOk} 
            onCancel={handleCancel}>
                <Row>
                    <Col span={24}>
                        <Input value={prodId} onChange={handleIdChange} placeholder="Id" maxLength="15" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Input value={nombre} onChange={handleNameChange} placeholder="Nombre" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Input value={description} onChange={handleDescriptionChange} placeholder="Descripción" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Input value={price} onChange={handlePriceChange} placeholder="Precio" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    <Col span={24}>
                        <Upload {...propsUpload}>
                            {fileList.length < 1 && '+ Upload'}
                        </Upload>
                    </Col>
                </Row>
            </Modal>

        </React.Fragment>
    )
}

export default ProductModalNew;



// WEBPACK FOOTER //
// ./src/components/ProductModalNew.jsx